import {Header} from '@/shared/constants/header'
import PropTypes from 'prop-types'

/**
 * HeaderTitle component renders a title with a specified heading level.
 *
 * @param {Object} props - The component props.
 * @param {string} props.title - The title text to be displayed.
 * @param {string} [props.className] - Optional CSS class to apply to the heading element.
 * @param {Header.PageHeader|Header.SectionTitle} [props.headingLevel=Header.SectionTitle] - The heading level to use for the title.
 * @returns {JSX.Element} The rendered header title element.
 */
export const HeaderTitle = ({title, className, headingLevel = Header.SectionTitle}) => {
  const getHeaderTitle = headingLevel => {
    let headerTitle = <>{title}</>
    if (headingLevel === Header.PageHeader) {
      headerTitle = <h1 className={className}>{title}</h1>
    } else if (headingLevel === Header.SectionTitle) {
      headerTitle = <h2 className={className}>{title}</h2>
    }

    return headerTitle
  }

  return <>{getHeaderTitle(headingLevel)}</>
}

HeaderTitle.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  headingLevel: PropTypes.string,
}
